import React from "react";
import Button from "./buttons/Button";
import { NavLink } from "react-router-dom";

export default function Hero() {
  return (
    <div className="hero">
      <div className="hero_container">
        <div className="hero_desc">
          <h1>Welcome to</h1>
          <h2>Asakaaplay</h2>
          <p style={{
            color: "#d4d4d4ff"
          }}>
            Get your High and Low Risk slips from The No. 1 Sports Prediction Guru.
          </p>

          <img
          className="hero_image"
          src="hero2.png"
          alt="hero"
        />

          <div className="hero_btns">
            <NavLink to={"/plan"}>
              <Button value={"Join Vip Page".toUpperCase()} className={"btn btn_white"} />
            </NavLink>
            <NavLink to={"https://t.me/asakaafixed01"} style={{backgroundColor: "hsl(168, 100%, 29%)", borderRadius: "5px"}}>
              <Button value="Join Telegram Channel" className={"btn btn_border"} showIcon={true} style={{backgroundColor: "red"}} />
            </NavLink>
          </div>
        </div>
        {/* <div style={{

        }}>Hello</div> */}
        {/* <img
          className="hero_image"
          src="hero2.png"
          alt="hero"
        /> */}
      </div>

      {/* <div className="navigations">
        <Swiper
          modules={[Navigation, Pagination, Scrollbar, A11y]}
          // spaceBetween={50}
          slidesPerView={3}
          scrollbar={{ draggable: true }}
        >
          <SwiperSlide>
            <Button value="Daily Two Odds" />
          </SwiperSlide>
          <SwiperSlide>
            <Button value="Expert Tips" />
          </SwiperSlide>
          <SwiperSlide>
            <Button value="Daily Free Odds" />
          </SwiperSlide>
          <SwiperSlide>
            <Button value="Rollover" />
          </SwiperSlide>

        </Swiper>
      </div> */}
    </div>
  );
}
